module.exports = {"id":"194718","name":"Amara Baby","rating":"72","photo":"./data/images/photos/1/194718.png","club":{"name":"Sp. Charleroi","logo":"./data/images/clubs/Sp.Charleroi.png"},"positions":["MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AmaraBaby0.json
// module id = 311
// module chunks = 0